import React from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '200px',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  borderColor: 'none',
  maxHeight: 500,
  overflow: 'auto',
  padding: 1,
  outline: 'none',
}

const SmallModal = ({ open, onClose, ...props }) => (
  <Modal open={open} onClose={onClose}>
    <Box sx={{ ...style, ...props.style }}>{props.children}</Box>
  </Modal>
)

export default SmallModal
